/**
 * Breakpoint (px) below which we treat the device as mobile for OAuth.
 * Matches Tailwind's default `md` so popup is used on md and up.
 */
const DESKTOP_MIN_WIDTH = 768

/**
 * True when the device has touch capability (phones, tablets, touch laptops).
 * Prefer maxTouchPoints when available; fallback to ontouchstart for older browsers.
 */
function isTouchDevice(): boolean {
  if (typeof navigator === 'undefined') return false
  if (navigator.maxTouchPoints != null && navigator.maxTouchPoints > 0) return true
  return typeof window !== 'undefined' && 'ontouchstart' in window
}

/**
 * Returns true when the current context is considered desktop for OAuth (use popup).
 * Returns false for narrow viewports or touch devices so OAuth redirects in the same window.
 * Safe to call from client components only; returns true when window is undefined (SSR).
 */
export function isDesktopViewport(): boolean {
  if (typeof window === 'undefined') return true
  const wideEnough = window.innerWidth >= DESKTOP_MIN_WIDTH
  const notTouch = !isTouchDevice()
  return wideEnough && notTouch
}
